var sanitizeUrl = require('@braintree/sanitize-url').sanitizeUrl;

export const getSanitizedUrl = (url: string): string => sanitizeUrl(url);
